
import { useEffect, useState } from "react";

import { identifyViewer } from "../../analytics/posthog";

// Migration contract #3 — the swappable auth surface.
//
// v0.5 backend: GET /api/auth/me, reading the session cookie set by the magic-
// link verify route. v1 backend (supplier-ui port): replace the fetch URL with
// the bison-commerce supplier-portal session endpoint. The shape returned to
// component callers stays the same so widgets/templates don't change.

export interface CurrentRoomUser {
    email: string;
    name?: string;
    slug?: string;
    staff?: boolean;
}

export interface UseCurrentRoomUserResult {
    user: CurrentRoomUser | null;
    loading: boolean;
}

const ENDPOINT = "/api/auth/me";

export function useCurrentRoomUser(): UseCurrentRoomUserResult {
    const [user, setUser] = useState<CurrentRoomUser | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const res = await fetch(ENDPOINT, { cache: "no-store" });
                if (cancelled) return;
                if (!res.ok) {
                    setUser(null);
                    return;
                }
                const data = (await res.json()) as { user: CurrentRoomUser | null };
                if (cancelled) return;
                setUser(data.user ?? null);
                if (data.user) identifyViewer(data.user);
            } catch {
                if (!cancelled) setUser(null);
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    return { user, loading };
}
